// The languages the speech recogniser understands (the same list as the server, core/transcribe.py LANGUAGES). "auto" lets it find out which one is spoken.
export const SPEECH_LANGUAGES = [
  ["auto", "Detect automatically"], ["en", "English"], ["ur", "Urdu"], ["hi", "Hindi"], ["pa", "Punjabi"], ["ar", "Arabic"],
  ["fa", "Persian"], ["tr", "Turkish"], ["bn", "Bengali"], ["id", "Indonesian"], ["fr", "French"], ["de", "German"], ["es", "Spanish"], ["pt", "Portuguese"],
  ["it", "Italian"], ["nl", "Dutch"], ["pl", "Polish"], ["el", "Greek"], ["ja", "Japanese"], ["ko", "Korean"], ["zh", "Chinese"], ["vi", "Vietnamese"], ["ru", "Russian"],
];

// Languages written from right to left (their subtitles are drawn and edited that way).
export const RTL_LANGUAGES = new Set(["ur", "ar", "fa", "ps", "sd", "he"]);
export const isRtlLanguage = (code) => RTL_LANGUAGES.has(String(code || "").split("-")[0]);

// Languages for which the free recognisers can be busy or limited: the page says so.
export const SLOW_LANGUAGES = new Set(["auto", "ur", "pa"]);
